module.exports = __webpack_public_path__ + "img/icon-achievement.62af0a6f.png";